import React, { Component } from 'react';
import Basic from '../../container/layouts/Basic';

class Budget extends Component {
    state = {  }
    render() {
        return (
            <Basic page="Budget" {...this.props}>
                <h4>Budget Page</h4>
                <ul>
                    <li>Répartition par catégories</li>
                    <li>Total dépense prévues par catégories</li>
                    <li>Jauge</li>
                    <li>...</li>
                </ul>

            </Basic>
        );
    }
}

export default Budget;